







export default {
  name: 'ThumbDownIcon',
  props: {
    color: {
      type: String,
      default: '#000'
    }
  }
}
